import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { ModalityLookup } from '../../../../core/context/modalities-lookup';
import { ProcedureSetsService } from '../../services/procedure-sets-service';

@Component({
  selector: 'app-procedure-set-details',
  imports: [
    CommonModule,
    NzCardModule,
    NzTagModule,
    NzIconModule,
    NzButtonModule,
    NzSpinModule,
    NzListModule,
    RouterModule,
  ],
  templateUrl: './procedure-set-details.html',
  styleUrl: './procedure-set-details.scss',
})
export class ProcedureSetDetailsComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly procedureSetsService = inject(ProcedureSetsService);

  readonly procedureSetId = Number(this.route.snapshot.paramMap.get('id'));
  readonly details = toSignal(this.procedureSetsService.getById(this.procedureSetId), {
    initialValue: null,
  });

  readonly typeLabel = computed(() => {
    const type = this.details()?.type;
    if (!type) return '-';

    return ModalityLookup.modalities.find((m) => m.code === type)?.name ?? type;
  });

  readonly visibilityLabel = computed(() => (this.details()?.isHidden ? 'Ukryty' : 'Widoczny'));

  readonly visibilityColor = computed(() => (this.details()?.isHidden ? 'red' : 'green'));

  readonly proceduresCount = computed(() => this.details()?.medServices?.length ?? 0);
}
